import { ReactNode } from "react";
import styled from "styled-components";

type StyledRowProps = {
  gap: string;
  marginBottom: string;
  alignItems: string;
  display: string;
  children?: ReactNode;
};

const StyledRow = styled.div<StyledRowProps>`
  display: ${(props: StyledRowProps) => props.display};
  gap: ${(props: StyledRowProps) => props.gap};
  align-items: ${(props: StyledRowProps) => props.alignItems};
  margin-bottom: ${(props: StyledRowProps) => props.marginBottom};
  max-width: calc(100% + ${(props: StyledRowProps) => props.gap});
`;

type Props = {
  gap: string;
  marginBottom: string;
  alignItems?: "start" | "end" | "center" | "stretch";
  display?: "none" | "inline" | "block" | "flex";
  children?: ReactNode;
};
export default function Row({
  children,
  gap,
  marginBottom,
  alignItems = "end",
  display = "flex",
}: Props) {
  return (
    <StyledRow gap={gap} marginBottom={marginBottom} alignItems={alignItems} display={display}>
      {children}
    </StyledRow>
  );
}
